<template>
  <div class="justify-center">
    <div class="subheading font-weight-light">
      <br>
      <div class="text-xs-center px-4">
        <v-checkbox v-model="vDeclaracionAceptada">
          <template v-slot:label>
            <span class="subheading black--text">{{ `${$cadenas.textoDeclaracionJurada()}` }}</span>
          </template>
        </v-checkbox>
      </div>
    </div>
    <div v-show="vDeclaracionAceptada">
      <template>
        <v-layout row justify-center>
          <v-dialog v-model="dialog" persistent max-width="800">
            <template v-slot:activator="{ on }">
              <v-btn color="success" outline round dark @click="llenarInformacion" v-on="on">
                <v-icon>send</v-icon>&nbsp;&nbsp;&nbsp;Enviar Solicitud
              </v-btn>
              <ChipFechaHora  v-show="(vDeclaracionAceptada)"/>
            </template>
            <v-card>
              <v-card-title>
                <h2 class="primary--text">
                  CONFIRMAR ENVÍO DE SOLICITUD
                </h2>
              </v-card-title>
              <v-card-text>
                <span>Su trámite está apunto de envíarse con la siguiente información y documentos adjuntos:</span>
                <br>
                <div class="mt-2" style="border-radius:6px;border: 1px solid gray;overflow:hidden;">
                <table border="1" class="table_documentos_adjuntados">
                  <tr v-for="(registro, index) in informacionRecuperada.informacion" :key="index">
                    <td v-if="registro != ''">{{ informacionRecuperada.documentos[index] }}</td>
                    <td v-if="registro != ''"
                      :style="{ fontWeight: informacionRecuperada.documentos[index] === 'Correo de la Empresa' ? 'bold' : 'normal' }">
                      {{ registro }}
                    </td>
                  </tr>
                  <tr v-for="(registro, index) in GetDocumentosCargados"
                    :key="index + informacionRecuperada.informacion.length">
                    <td v-if="registro != ''">
                      {{ registro.documento }}
                    </td>
                    <td v-if="registro != ''">
                      {{ registro.nombre }}
                    </td>
                  </tr>
                </table>
                </div>
                <br>
                <span>¿Está seguro de enviar su solicitud de <strong>OTORGACIÓN DE CREDENCIALES?</strong></span>
                <h3 v-if="!habilitarEnvio" :style="{ color: 'red' }">
                  Para continuar con la solicitud, es necesario que adjunte todos los documentos en formato digital,
                  (Escaneados de los documentos originales (firmados cuando corresponda)).
                </h3>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="red darken-1" flat @click="dialog = false">
                  No
                </v-btn>
                <v-btn color="green darken-1" flat :disabled="!habilitarEnvio" @click="enviarSolicitud();">
                  Si
                </v-btn>
                <!-- <v-btn color="green darken-1" flat
                  @click="enviarSolicitud();">Si</v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </template>
      <HorarioAtencion />
      <br><br><br>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import types from '@/store/types/SolicitudCredenciales'
import ChipFechaHora from "@/components/ChipFechaHora.vue";
import HorarioAtencion from "@/components/HorarioAtencion.vue";
import typesSolicitudCredencial from '@/store/types/SolicitudCredenciales'
export default {
  components: {
    ChipFechaHora,
    HorarioAtencion,

  },
  props: {
    actualizar: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      vLoading: false,
      checkbox: false,
      vDeclaracionAceptada: false,
      dialog: false,
      informacionRecuperada: { documentos: [], informacion: [] },
      informacionMostrar: {},
      mensaje: "",
      habilitarEnvio: false,
      docNecesarios: [],
      datosEnviar: {},
    }
  },
  watch: {
    GetDocumentosCargados: {
      handler() {
        this.habilitarEnvio = this.validarCantidadDocumentos()
      },
      deep: true
    }
  },
  mounted() {
    this.cargarDocsNeesarios()
  },
  methods: {
    llenarInformacion() {
      if (this.GetDatosGuardados.resultado) {
        this.datosEnviar = {
          tokenAcceso: this.$route.params.codigo,
          nombreEmpresa: this.GetDatosSin.resultado.nombreRazonSocial,
          direccionEmpresa: this.GetDatosSin.resultado.direccion + " " + this.GetDatosSin.resultado.direccionDescriptiva,
          telefonoEmpresa: this.GetDatosSin.resultado.telefonoEmpresa,
          nitEmpresa: this.GetDatosSin.resultado.nit,
          nombrePropietarioEmpresa: this.GetDatosRepresentante.Nombres + " " + this.GetDatosRepresentante.PrimerApellido + " " + this.GetDatosRepresentante.SegundoApellido,
          numeroCiPropietarioEmpresa: this.GetDatosRepresentante.NumeroDocumento,
          correoNotificacionEmpresa: this.GetDatosGuardados.resultado.correoNotificacionEmpresa,
          dependencia: this.GetDatosSin.resultado.dependencia,
          telefonoRepresentante: this.GetDatosGuardados.TelefonoRepresentante,
          correoRepresentante: this.GetDatosRepresentante.CorreoRepresentante
        }
        this.informacionRecuperada = {
          documentos: ["NIT",
            "Nombre o Razon Social",
            "Departamento de Domicilio Fiscal",
            "Dirección de la Empresa",
            "Teléfono de la Empersa",
            "Correo de la Empresa",
            "Representante Legal",
            "Cedula de Identidad del Representante",
            "Teléfono del Representante",
            "Correo del Representante",
          ],
          informacion: [
            this.datosEnviar.nitEmpresa,
            this.datosEnviar.nombreEmpresa,
            this.datosEnviar.dependencia,
            this.datosEnviar.direccionEmpresa,
            this.datosEnviar.telefonoEmpresa,
            this.datosEnviar.correoNotificacionEmpresa,
            this.datosEnviar.nombrePropietarioEmpresa,
            this.datosEnviar.numeroCiPropietarioEmpresa,
            this.GetDatosRepresentante.TelefonoRepresentante,
            this.GetDatosRepresentante.CorreoRepresentante,
          ]
        }
      }
      this.actualizar()
    },
    enviarSolicitud() {
      if (this.validarCantidadDocumentos()) {
        this.SetEditando(false)
        this.EnviarSolicitud(
          this.datosEnviar
        ).then((r) => {
          if (r.data.status === 200) {
            this.$cadenas.Mensaje(
              "notificacion",
              "Mensaje",
              "Se ha enviado la solicitud de credencial ",
              "success"
            );

            this.GenerarFormularioR_0530(this.$route.params.codigo,
            ).then((r) => {
              let blob = new Blob([r.data], {
                type: "application/pdf",
              });
              let link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = r.headers["content-disposition"];
              document.body.appendChild(link);
              link.click();
              //this.SetdialogProgress(false);
              this.LimpiarSolicitudTodos();

            });
            this.SetDatosGuardados({})
            this.SetDatosRepresentante({})
            this.SetDatosSin({})
          } else {
            this.$cadenas.Mensaje(
              "notificacion",
              "Mensaje",
              r.message,
              "error"
            );
          }
        });
      }
    },
    validarCantidadDocumentos() {
      const docNecesarios1 = ["MATRICULA ACTUALIZADA REGISTRO DE COMERCIO (FUNDEMPRESA)", "CEDULA DE IDENTIDAD", "CERTIFICADO INSCRIPCION PADRON NACIONAL DE CONTRIBUYENTES (SIN)"]
      return this.docNecesarios.every(doc =>
        this.GetDocumentosCargados.some(presente => presente.documento === doc)
      );
    },
    async cargarDocsNeesarios() {
      this.ListaDocumentosCredenciales({ solicitudId: this.GetDatosGuardados.resultado.solicitudId, criterio: 'DOCS. SOLICITUD CREDENCIAL VIA WEB' }).then(
        r => {
          this.docNecesarios = r.data.resultado.map(item => item.descripcionTipoDocumento)
        })
    },
    ...mapMutations({
      SetDatosGuardados: types.mutations.SetDatosGuardados,
      SetEditando: types.mutations.SetEditando,
      SetDatosSin: types.getters.SetDatosSin,
      SetDatosRepresentante: types.getters.SetDatosRepresentante,
    }),
    ...mapActions({
      RecuperarDatosGuardados: types.actions.RecuperarDatosGuardados,
      GenerarFormularioR_0530: typesSolicitudCredencial.actions.GenerarFormularioR_0530,
      EnviarSolicitud: typesSolicitudCredencial.actions.EnviarSolicitud,
      ListaDocumentosCredenciales: typesSolicitudCredencial.actions.ListaDocumentosCredenciales,
    })
  },
  computed: {
    ...mapGetters({
      GetDatosGuardados: types.getters.GetDatosGuardados,
      GetValidacionEnCurso: types.getters.GetValidacionEnCurso,
      GetDocumentosCargados: types.getters.GetDocumentosCargados,
      GetDatosSin: types.getters.GetDatosSin,
      GetDatosRepresentante: types.getters.GetDatosRepresentante,
    }),
  },
}

</script>

<style>
.table_documentos_adjuntados {
  border-collapse: collapse;
  width: 100%;
  border-radius: 6px;
  border: 1px solid gray;
  overflow: hidden;
}

.table_documentos_adjuntados tr {
  border-bottom: 1px solid gray;
}

.table_documentos_adjuntados tr td {
  padding: 8px;
}
</style>
